import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { TransactionCreditBaseEffect } from './transaction-credit-base.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ TransactionCreditBaseEffect ])
  ]
})
export class TransactionCreditBaseModule {

}
